import { useEffect, useMemo, useState } from "react";
import { SidebarLink } from "./SidebarLink";

import { LocationPageInterface } from "@swivl-mono/types";
import { Input } from "@swivl-mono/ui";
import { IconType } from "react-icons";
import { FaSearch } from "react-icons/fa";
import { ShowIf } from "../ShowIf/ShowIf";
import { RouterWorksheetData } from "../Worksheets/Types/Worksheet.Interface";
import { SidebarSectionHeading } from "./SidebarSectionHeading";

interface Props {
  items: RouterWorksheetData[];
  prefix?: string;
  suffix?: string;
  page?: LocationPageInterface
}

export function SearchableSidebarLinksList(props: Props) {
  const [search, setSearch] = useState("");
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({});

  useEffect(() => {
    if (!search) return;

    const newOpenSections: Record<string, boolean> = {};
    props.items.forEach((item) => {
      const isParentMatch = item.label.toLowerCase().includes(search.toLowerCase());
      const matchingChildren = item.children?.filter((child) => {
        return child.label.toLowerCase().includes(search.toLowerCase())
      }) ?? [];

      if (isParentMatch || matchingChildren.length > 0) {
        newOpenSections[item.to] = true;
      }
    }
    );
    setOpenSections(newOpenSections);
  }, [search, props.items])

  const filtered = useMemo(() => {
    if (!props.items) return [];

    const searchLower = search.toLowerCase();
    return props.items.map((item) => {
      const isParentMatch = item.label.toLowerCase().includes(searchLower);

      const matchingChildren = item.children?.filter((child) => {
        return child.label.toLowerCase().includes(searchLower)
      }) ?? [];

      if (isParentMatch) {
        return {
          ...item,
          children: item.children ?? [],
        };
      }

      if (matchingChildren.length > 0) {
        return {
          ...item,
          children: matchingChildren,
        };
      }

      return null;
    }).filter(Boolean)
  }, [props.items, search]);

  const handleToggle = (to: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [to]: !prev[to],
    }));
  };

  return (
    <div className="SearchableSidebarLinksList">
      <Input className="mt-3 mx-2" placeholder="Search..." rightIcon={<FaSearch /> as unknown as IconType} isRound={true} value={search} onChange={(e) => setSearch(e.target.value)} />
      {filtered && filtered.map((item) => {
        if (item?.children && item.children.length > 0) {
          const to = `${props.prefix || ""}/${item.to}`;
          if (item.apiScope) {
            return <ShowIf scope={item.apiScope}><SidebarSectionHeading key={to} openOnPath={to} isOpen={openSections[item.to]} onToggle={() => handleToggle(item.to)} items={item.children}>{item.label}</SidebarSectionHeading></ShowIf>
          }
          return <SidebarSectionHeading key={to} openOnPath={to} onToggle={() => handleToggle(item.to)} isOpen={openSections[item.to]} items={item.children}>{item.label}</SidebarSectionHeading>
        }

        const to = `${props.prefix || ""}/${item?.to}${props.suffix ? `/${props.suffix}` : ""}`;
        if (item && item?.apiScope) {
          return (
            <ShowIf scope={item.apiScope}>
              <SidebarLink height={38} key={to} to={to}>{item.label}</SidebarLink>
            </ShowIf>
          )
        }
        return <SidebarLink height={38} key={to} to={to}>{item?.label}</SidebarLink>
      })}
    </div>
  );
}

